import { queryOptions, useQuery } from '@tanstack/react-query';

import { getPromoCount } from '../queries/promos';
import { useAuthStore, useShipToStore } from '../stores';

export const PROMO_COUNT_QUERY_KEY = 'PromoCount';

export function getCountPromoOptions(
  access_token: string,
  warehouse: string,
  enabled = true
) {
  return queryOptions({
    queryKey: [PROMO_COUNT_QUERY_KEY],
    queryFn: () => getPromoCount(access_token, warehouse),
    retry: false,
    enabled: !!warehouse && enabled,
    staleTime: 1000 * 60 * 4,
  });
}

export const useGetPromoCount = ({ enabled = true } = {}) => {
  const session = useAuthStore();
  const { selectedShipToId } = useShipToStore();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useQuery(
    getCountPromoOptions(session.access_token, selectedShipToId, enabled)
  );
};
